<!-- 工单详情 -->
<template>
  <div>
    <a-modal
      v-if="visible"
      v-model:visible="visible"
      title=""
      @cancel="handleCancel"
      :centered="true"
      :destroyOnClose="true"
      width="80%"
      :bodyStyle="{
        height: '80vh',
        padding: '18px'
      }"
      :footer="null"
      class="patient-wrap"
    >
      <a-tabs type="card" v-model:activeKey="activeKey" @change="handleChange" class="patient-tabs">
        <a-tab-pane :key="tab.key" :tab="tab.label" v-for="tab in supportTabs">
          <component
            class="detailComponent"
            :is="tab.component"
            mode="read"
            :ref="tab.ref"
            :ucUserId="currentInfo.ucPatientId"
            :patientName="currentInfo.ucPatientName"
            :workOrderId="currentInfo.workOrderId"
            :followBusinessType="currentInfo?.followBusinessType"
            :id="currentInfo?.id"
            :groupId="groupId"
            :privateId="privateId"
            :guideConsultGroupId="guideConsultGroupId"
            :doctorDaGroupId="doctorDaGroupId"
            @closeSummaryModal="handleCancel"
          />
        </a-tab-pane>
      </a-tabs>
    </a-modal>
  </div>
</template>
<script setup>
import { defineProps, computed, defineEmits, ref, watch } from 'vue'
import { tabs } from './config'
import useChat from './hooks/useChat'
import { subOrderTypes, followBusinessTypes } from '@/config/workOrderConfig'
const { groupId, privateId, guideConsultGroupId, doctorDaGroupId, lookChatHistory } = useChat()
const props = defineProps({
  currentInfo: {
    type: Object,
    default: () => {},
    required: true
  },
  showAllDialog: {
    type: Boolean,
    default: false,
    require: true
  },
  onlyPatientInfo: {
    // 只展示患者信息，不展示工单详情和会话记录
    type: Boolean,
    default: false
  },
  activeTab: {
    // 只展示某个tab
    type: Number,
    default: 0
  }
})
const supportTabs = ref([])
const emits = defineEmits(['handleCancel'])
const visible = computed(() => props.showAllDialog)
const activeKey = ref(1)
watch(
  () => props.showAllDialog,
  val => {
    const { businessType, followBusinessType } = props.currentInfo
    // 判断子工单存在并且工单中需要子工单弹窗明细
    if (followBusinessType && subOrderTypes.includes(businessType)) {
      // followBusinessType:子工单工单类型
      const { infoDetails = {} } = followBusinessTypes[followBusinessType]
      // 默认激活的tab
      activeKey.value = infoDetails?.activeKey
      // 设置子工单下的tabs，默认取配置的如果没有配置则取全部tabs
      const arr = infoDetails?.supportTabs
      supportTabs.value = infoDetails?.supportTabs ? tabs.filter(it => arr.includes(it.ref)) : tabs
    } else {
      if (businessType === 10) {
        activeKey.value = 1
        // const arr = ['workorderDetails', 'chat', 'Gauge']
        supportTabs.value = tabs
      } else if ([28, 29, 34].includes(businessType)) {
        activeKey.value = 1
        const arr = ['workorderDetails', 'chat']
        supportTabs.value = tabs.filter(it => arr.includes(it.ref))
      } else {
        if (val && props.onlyPatientInfo) {
          // 不包含下面内容
          const arr = ['workorderDetails', 'chat']
          activeKey.value = 3
          supportTabs.value = tabs.filter(it => !arr.includes(it.ref))
        } else if (props.activeTab) {
          activeKey.value = props.activeTab
          supportTabs.value = tabs.filter(it => it.key === props.activeTab)
          handleChange()
        } else {
          activeKey.value = 1
          supportTabs.value = tabs
        }
      }
    }
  }
)
const handleCancel = () => {
  emits('handleCancel')
}
const handleChange = () => {
  if (activeKey.value == 2) {
    lookChatHistory(props.currentInfo)
  }
}
</script>
<style scoped lang="scss">
.patient-wrap {
  .patient-tabs {
    ::v-deep(.ant-tabs-top-content, .ant-tabs-bottom-content) {
      max-height: calc(80vh - 76px);
      overflow: scroll;
    }
  }
}
</style>
